module.exports = __webpack_public_path__ + "img/logo.cb183706.png";